import { useTranslation } from "react-i18next";
import { styled } from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #0e6c53; /* $green from customVariables */
  height: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: 400px;
`;

const Title = styled.div`
  padding: 0 17px 13px 11px;
`;

const InnerContainer = styled.div`
  color: #ffffff; /* $white from customVariables */
  font-size: 1.375rem; /* $medium-large-font-size from fonts */
  padding: 32px;
`;

export const Maintenance = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Wrapper>
        <Title>
          <img src={"/img/mindler_primary.svg"} />
        </Title>
        <InnerContainer>{t("MAINTENANCE_WARNING")}</InnerContainer>
      </Wrapper>
    </Container>
  );
};
